import React from 'react'
import './App.css';
import Game from './components/Game'



function App() {
  return (
    <div id="app">
      <Game />
    </div>
  )
}

export default App
